<template>
  <div>
    <div class="bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end pt-3 pl-3 pr-3 mb-3">
      <div class="d-flex flex-column">
        <h4 class="mb-0">Alignment</h4>
        <p class="mb-0">The Member Stack can be vertical aligned or horizontal aligned.</p>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : view === 'preview'}" @click="view = 'preview'">Preview</b-button>
        <b-button :class="{'active' : view === 'code'}"  @click="view = 'code'">Code</b-button>
      </ButtonGroup>
    </div>

    <CodePreviewViewer :viewMode="view" :codeSample="require('./member_stack_alignment.js').default">
      <template v-slot:preview>
        <div class="bg-white rounded shadow-sm p-3 w-100">
          <span>Vertical Alignment</span>
          <MemberStack
            class="mb-3"
            :members="members"
            vertical
          />
          <span>Horizontal Alignment</span>
          <MemberStack
            :members="members"
          />
        </div>
      </template>
    </CodePreviewViewer>
    </div>
  </div>
</template>

<script>
import MemberStack from '@/components/export/MemberStack/MemberStack'
import ButtonGroup from '@/components/export/ButtonGroup/ButtonGroup'
import CodePreviewViewer from '@/components/local/CodePreviewViewer'

export default {
  components: { ButtonGroup, CodePreviewViewer, MemberStack },
  data () {
    return {
      view: 'preview',
      viewSizing: 'preview',
      text:'',
      errors: 'Sample error message here',
      members: [
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Kobe Bryant' },
        { img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVVroxhjO7nMBR1aBAEo-iv2u6So86lqdL2Q&usqp=CAU', name: 'Killua Zoldyck' },
        { img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcShZKvaqaDJPLVr83tQ_fDT6-zQfa-SCe700oFdPoF4S2y_lJnbX_68Uz-7BnjssKQaemE&usqp=CAU', name: 'Mikasa Ackermann' },
        { img: 'https://pbs.twimg.com/profile_images/1185108123272376321/SuWaywoV_400x400.jpg', name: 'Golden Brown' },
        { img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5ygMsYQQd7_E1XEhOp5EvQqryzTBgVEZBUQ&usqp=CAU', name: 'Joe Harris' },
        { img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcShZKvaqaDJPLVr83tQ_fDT6-zQfa-SCe700oFdPoF4S2y_lJnbX_68Uz-7BnjssKQaemE&usqp=CAU', name: 'Steve Joe' },
      ]
    }
  },
  methods: {
    memberClicked (member) {
      alert(member.name)
    }
  }
}
</script>

<style>

</style>